/**
 * Workflow types currently supported in the product. Values are lowercase
 * template keys (e.g. "admission", "arbitration") so they match API + template naming.
 *
 * Templates may still introduce unknown keys — UI treats those as free-form
 * strings (humanized labels, hashed colors).
 */
export enum WorkflowType {
  ADMISSION = "admission",
  ARBITRATION = "arbitration",
}

export type WorkflowOption = Readonly<{
  /** Lowercase workflow type from the facility template (e.g. "admission", "arbitration"). */
  type: string;
  label: string;
}>;
